<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>总用户数</span>
              <el-icon><User /></el-icon>
            </div>
          </template>
          <div class="card-body">
            <h2>{{ stats.userCount || 0 }}</h2>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>今日订单</span>
              <el-icon><ShoppingCart /></el-icon>
            </div>
          </template>
          <div class="card-body">
            <h2>{{ stats.todayOrders || 0 }}</h2>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>今日收入</span>
              <el-icon><Money /></el-icon>
            </div>
          </template>
          <div class="card-body">
            <h2>¥{{ stats.todayRevenue || 0 }}</h2>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>手抄报数量</span>
              <el-icon><Document /></el-icon>
            </div>
          </template>
          <div class="card-body">
            <h2>{{ stats.handCopyCount || 0 }}</h2>
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="12">
        <el-card>
          <template #header>
            <span>最近订单</span>
          </template>
          <el-table :data="recentOrders" style="width: 100%">
            <el-table-column prop="order_no" label="订单号" />
            <el-table-column prop="total_amount" label="金额">
              <template #default="{ row }">
                ¥{{ row.total_amount }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template #default="{ row }">
                <el-tag :type="getStatusType(row.status)">
                  {{ getStatusText(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="时间" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <template #header>
            <span>待审核手抄报</span>
          </template>
          <el-table :data="pendingHandCopies" style="width: 100%">
            <el-table-column prop="title" label="标题" />
            <el-table-column prop="category_name" label="分类" />
            <el-table-column prop="created_at" label="提交时间" />
            <el-table-column label="操作">
              <template #default="{ row }">
                <el-button type="primary" size="small" @click="auditHandCopy(row)">审核</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import request from '../utils/request'

export default {
  name: 'Dashboard',
  setup() {
    const stats = ref({})
    const recentOrders = ref([])
    const pendingHandCopies = ref([])
    
    const getStatusType = (status) => {
      const types = { 0: 'warning', 1: 'success', 2: 'primary', 3: 'success', '-1': 'danger' }
      return types[status] || 'info'
    }
    
    const getStatusText = (status) => {
      const texts = { 0: '待支付', 1: '已支付', 2: '处理中', 3: '已完成', '-1': '已取消' }
      return texts[status] || '未知'
    }
    
    const fetchStats = async () => {
      try {
        const res = await request.get('/api/admin/statistics')
        stats.value = res.data
        
        // 获取最近订单
        const orderRes = await request.get('/api/admin/shop-orders', { params: { limit: 5 } })
        recentOrders.value = orderRes.data || []
        
        // 获取待审核手抄报
        const handCopyRes = await request.get('/api/admin/hand-copy', { params: { status: 0, limit: 5 } })
        pendingHandCopies.value = handCopyRes.data || []
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    }
    
    const auditHandCopy = (row) => {
      // 跳转到审核页面
    }
    
    onMounted(() => {
      fetchStats()
    })
    
    return {
      stats,
      recentOrders,
      pendingHandCopies,
      getStatusType,
      getStatusText,
      auditHandCopy
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.card-header span {
  font-weight: 600;
  color: #606266;
  font-size: 14px;
}

.card-header .el-icon {
  font-size: 20px;
  color: #409EFF;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.1) 0%, rgba(102, 177, 255, 0.1) 100%);
  padding: 8px;
  border-radius: 10px;
}

.card-body {
  padding: 16px 0 8px;
}

.card-body h2 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #303133 0%, #606266 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 统计卡片动画 */
.el-col:nth-child(1) .el-card {
  border-top: 3px solid #409EFF;
}

.el-col:nth-child(2) .el-card {
  border-top: 3px solid #67C23A;
}

.el-col:nth-child(3) .el-card {
  border-top: 3px solid #E6A23C;
}

.el-col:nth-child(4) .el-card {
  border-top: 3px solid #F56C6C;
}

.el-card {
  transition: all 0.3s ease;
}

.el-card:hover {
  transform: translateY(-4px);
}
</style>
